export default (primary, secondary, third) => ({
    primary,
    secondary,
    third,
});
